import { render, staticRenderFns } from "./EnrolleebyLGAandFacility.vue?vue&type=template&id=d1504f6a&"
import script from "./EnrolleebyLGAandFacility.vue?vue&type=script&lang=js&"
export * from "./EnrolleebyLGAandFacility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports